import React, {FC} from "react"
import {Row, Col} from "@irati/ui/src/Layout"

import FormattedMessage from "@irati/utils/lang"
import {H6} from "@irati/ui/src/Typography"

const UnavailableDeal: FC = () => {
  return (
    <Row>
      <Col xs={8} sm={12}>
        <H6>
          <FormattedMessage id="perks.components.dealBody.unavailableDeal.header" />
        </H6>
      </Col>
    </Row>
  )
}

export default UnavailableDeal
